import Dashboard from "../pages/protectedPages/dashboard";
import AppointmentRoom from "../pages/protectedPages/appointmentRoom";
import SetCalendar from "../pages/protectedPages/setCalendar";
import Transactions from "../pages/protectedPages/transactions";
import DoctorInfo from "../pages/protectedPages/doctorInfo";
import Profile from "../pages/protectedPages/profile";
import DrSettings from "../pages/protectedPages/doctorSetting";
import MedicalHistory from "../pages/protectedPages/medicalHistory";
import IncreaseCredit from "../pages/protectedPages/increaseCredit";
import WithdrawalRequest from "../pages/protectedPages/withdrawalRequest";
import PatientTransactions from "../pages/protectedPages/patientTransactions";
import PatientSettings from "../pages/protectedPages/patientSettings";
// import NoMatch from "../pages/noMatch";
const commonRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/appointment",
    component: AppointmentRoom,
    dynamic: true,
  },
  {
    path: "/profile",
    component: Profile,
  },
  // {
  //   path: "*",
  //   component: NoMatch,
  // },
];
const userRoutes = [
  {
    path: "/medical-history",
    component: MedicalHistory,
  },
  {
    path: "/increase-credit",
    component: IncreaseCredit,
  },
  {
    path: "/withdrawal-request",
    component: WithdrawalRequest,
  },
  {
    path: "/patient-transactions",
    component: PatientTransactions,
  },
  {
    path: "/patient-settings",
    component: PatientSettings,
  },
];

const drRoutes = [
  {
    path: "/set-calendar",
    component: SetCalendar,
  },
  {
    path: "/doctor-info",
    component: DoctorInfo,
  },
  {
    path: "/transactions",
    component: Transactions,
  },
  {
    path: "/dr-settings",
    component: DrSettings,
  },
];

export { commonRoutes, userRoutes, drRoutes };
